import {parse} from 'query-string';
import {Subject, combineLatest, ReplaySubject} from 'rxjs';
import {filter, map, skipUntil, scan, switchMap, shareReplay, throttleTime} from 'rxjs/operators';
import {klineApi} from '@/api/kline';
import {mockUtil} from '@/helper/moc';
import {browser$} from '@/streams/browser';
import {spots$} from '@/streams/config/spot';
import {contracts$} from '@/streams/config/contract';

const chunkSize = 200;
const loadThrottleTime = 60 * 1000; // 60s
const loadTrends$ = new Subject();
const originProductListArr$ = new Subject();
const productListArr$ = new Subject();
const updateTrends$ = new ReplaySubject();

export const trends$ = updateTrends$.pipe(
  scan((trends, cur) => {
    const newTrends = cur.reduce((p, c) => {
      p[c.symbol] = c;
      return p;
    }, {});
    return {...trends, ...newTrends};
  }, {}),
  shareReplay(1)
);

combineLatest([originProductListArr$, loadTrends$])
  .pipe(throttleTime(loadThrottleTime))
  .subscribe(([o]) => {
    productListArr$.next([...o]);
  });

productListArr$.pipe(switchMap(getTrends)).subscribe(([o, trends]) => {
  updateTrends$.next(trends);
  if (o.length > 0) {
    productListArr$.next(o);
  }
});

combineLatest([spots$, contracts$])
  .pipe(
    skipUntil(browser$),
    filter(([spots, contracts]) => (mockUtil.isMock() ? spots.concat(contracts).length > 0 : spots.length > 0 && contracts.length > 0)),
    map(([spots, contracts]) => convertSymbols(spots, contracts)),
    filter((o) => o.length > 0),
    shareReplay(1)
  )
  .subscribe((o) => {
    originProductListArr$.next(o);
    loadTrends$.next();
  });

async function getTrends(symbolsList) {
  const curSymbols = symbolsList.shift();
  const trends = await klineApi.getTrend({symbol: curSymbols.join(',')});
  return [symbolsList, trends.data || []];
}

function convertSymbols(spots, contracts) {
  const {tabType} = parse(window.location.search);
  if (tabType === 'Contract') {
    return [...convertTradeSymbol(contracts), ...convertTradeSymbol(spots)];
  }
  return [...convertTradeSymbol(spots), ...convertTradeSymbol(contracts)];
}

function convertTradeSymbol(trades) {
  return chunkArray(trades.map((o) => o.symbol).sort(), chunkSize);
}

function chunkArray(array, size) {
  const length = array.length;
  if (length === 0 || size < 1) {
    return [];
  }
  let index = 0;
  let resIndex = 0;

  let result = new Array(Math.ceil(length / size));
  while (index < length) {
    result[resIndex++] = array.slice(index, (index += size));
  }
  return result;
}
